import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  > form {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

interface AvatarContainerProps {
  isLoading?: boolean;
}

export const AvatarContainer = styled.div<AvatarContainerProps>`
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  color: var(--white);

  > div {
    width: 150px;
    height: 150px;
    position: relative;
  }

  > div img {
    height: 150px;
    width: 150px;
    object-fit: cover;
    border-radius: 50%;

    ${props =>
      props.isLoading &&
      css`
        opacity: 0.5;
      `}
  }

  ${props =>
    props.isLoading &&
    css`
      > div:last-child {
        position: absolute;
      }
    `}

  input {
    display: none;
  }

  label {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--black-transparent);
    color: var(--white);
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;

    outline: none;
    transition: box-shadow 0.2s ease-in-out;
  }
`;

export const BlueLink = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  color: var(--info);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;
